import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Button, ButtonGroup } from 'react-bootstrap'

import NavigationBar from '../components/NavigationBar'
import AdminNavBar from '../components/Admin/AdminNavBar'
import Footer from '../components/Footer/Footer'
import { AuthContext } from '../contexts/AuthContext'
import { useAuth } from '../contexts/AuthContext'
import { LOGIN_PATH } from '../config/routes'
import config from '../config/config'
import { setFlashMessage, useWebsite } from '../contexts/WebsiteContext'
import CommentThumbnail from '../components/Admin/CommentThumbnail'

const ManageComments = () => {
  const { token } = useAuth()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { isAdmin, logout } = useContext(AuthContext)
  const [comments, setComments] = useState([])
  const [filterStatus, setFilterStatus] = useState('NEW')

  useEffect(() => {
    const fetchComments = async () => {
      try {
        const response = await axios.get(`${config.apiUrl}poi-comment`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            status: filterStatus,
          },
        })
        setComments(response.data)
      } catch (error) {
        //console.error('Error webservice call:', error);

        if (error.response && error.response.status === 401) {
          logout()
          navigate(LOGIN_PATH)
        } else if (error.response) {
          setFlashMessage(t('ERROR_MESSAGE'), 'error')
        }
      }
    }

    fetchComments()
  }, [isAdmin, logout, navigate, token, filterStatus, t])

  const handleFilterChange = (status) => {
    setFilterStatus(status)
  }

  const handleStatusChange = (commentId, newStatus) => {
    setComments((prevComments) =>
      prevComments.map((comment) =>
        comment.id === commentId ? { ...comment, status: newStatus } : comment,
      ),
    )
  }

  return (
    <div>
      <NavigationBar />
      <AdminNavBar />
      <h1>{t('MANAGE_COMMENTS_TITLE')}</h1>
      <ButtonGroup
        className="mb-2"
        style={{ textAlign: 'center', marginLeft: '10px' }}
      >
        <Button
          variant={filterStatus === 'NEW' ? 'primary' : 'secondary'}
          onClick={() => handleFilterChange('NEW')}
        >
          {t('NEW')}
        </Button>
        <Button
          variant={filterStatus === 'VALIDATED' ? 'primary' : 'secondary'}
          onClick={() => handleFilterChange('VALIDATED')}
        >
          {t('VALIDATED')}
        </Button>
        <Button
          variant={filterStatus === 'REJECTED' ? 'primary' : 'secondary'}
          onClick={() => handleFilterChange('REJECTED')}
        >
          {t('REJECTED')}
        </Button>
      </ButtonGroup>
      <div style={{ marginBottom: '20px' }}>
        {comments.length > 0 ? (
          comments
            .filter((comment) => comment.status === filterStatus)
            .map((comment) => (
              <CommentThumbnail
                key={comment.id}
                comment={comment}
                onStatusChange={handleStatusChange}
              />
            ))
        ) : (
          <p
            className="green-frame"
            style={{ margin: '5px', paddingBottom: '10px' }}
          >
            {t('NO_COMMENTS')}
          </p>
        )}
      </div>
      <img
        className="img-fluid"
        src="/images/photos/95cc8f97-0f60-4275-a019-d2f30f928658.jpg"
        alt="La carrière de marbre de Sost"
      />
      <Footer />
    </div>
  )
}

export default ManageComments
